import React from "react";
import "./TrustAndRatingsSection.css";
import googleLensLogo from "../images/google-lens.webp";
import deccanHeraldLogo from "../images/deccan-herald.svg";
import g2Logo from "../images/g2-logo.webp";

const TrustAndRatingsSection = ({ isSmallScreen }) => {
    const distributions = [
        {
            logo: googleLensLogo,
            header: "4.9 / 5",
            subHeader: "1000+ Google Reviews",
            width: 117,
            height: 120,
        },
        {
            logo: deccanHeraldLogo,
            header: "Ranked No. 1",
            subHeader: "Deccan Herald",
            width: 351,
            height: 285,
        },
        {
            logo: g2Logo,
            header: "4.7 / 5",
            subHeader: "G2 Rating",
            width: 120,
            height: 120,
        },

    ];

    return (
        <div
            className="trust-ratings-section"
            style={{
                width: "100%",
                padding: isSmallScreen ? "12px 0" : "18px 0",
                borderBottom: "1px solid #E0E0E0",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-evenly",
                    alignItems: "center",
                    maxWidth: "1000px",
                    margin: "0 auto",
                }}
            >
                {distributions.map((item, index) => (
                    <div
                        key={index}
                        className="trust-ratings-item"
                        style={{
                            textAlign: "center",
                            width: "33%",
                            fontFamily: "Poppins, sans-serif",
                        }}
                    >
                        <img
                            src={item.logo}
                            alt={item.subHeader}
                            width={item.width}
                            height={item.height}
                            decoding="async"
                            style={{
                                height: isSmallScreen ? 34 : 54,
                                width: "auto",
                                objectFit: "contain",
                                marginBottom: 5,
                            }}
                        />

                        <div
                            style={{
                                fontSize: isSmallScreen ? 10 : 15,
                                marginTop: 2,
                                fontWeight: 600,
                            }}
                        >
                            {item.header}
                        </div>

                        <div
                            style={{
                                fontSize: isSmallScreen ? 9 : 12,
                                marginTop: 2,
                                color: "#666",
                            }}
                        >
                            {item.subHeader}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TrustAndRatingsSection;